import React from "react";
import "./makePay.css";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const MakePay = () => {
  const location = useLocation();
  const formData = location.state;

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    navigate("/DepositAgain");
  };

  return (
    <>
      <div className="makePayPage">
        <h4>
          Please send your payments to our Company Bitcoin Wallet Address below:
        </h4>
        <div className="wrapn">
          <p>
            bc1q05w3jqheur2szahw5pmuy26tpfqv96ymc <br />
            sz6kt
          </p>
        </div>
        {formData ? (
          <div className="amount-table">
            <h4 className="confirm-dep">PLEASE CONFIRM YOUR DEPOSIT</h4>
            <table>
              <tr>
                <td>
                  <strong>Credit Amount:</strong>
                </td>
                <td>${formData.amount}</td>
              </tr>
              <tr>
                <td>
                  <strong>Deposit Fee:</strong>
                </td>
                <td>None</td>
              </tr>
              <tr>
                <td>
                  <strong>Debit Amount:</strong>
                </td>
                <td>${formData.amount}</td>
              </tr>
            </table>
          </div>
        ) : (
          <p>No data available.</p>
        )}
        <br />
        <div className="makePayHash">
          <form onSubmit={handleSubmit}>
            <h4>Required Information</h4>
            <label htmlFor="hash">
              Transaction Hash
              <input type="text" name="hash" id="hash" />
            </label>
            <button type="submit">SAVE</button>
            <button type="submit">CANCEL</button>
          </form>
        </div>
      </div>
    </>
  );
};

export default MakePay;
